export const Crop = props => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4 4H11" stroke="currentColor" strokeLinecap="round" />
      <path d="M4 4V11" stroke="currentColor" strokeLinecap="round" />
      <path d="M13 20H20" stroke="currentColor" strokeLinecap="round" />
      <path d="M20 13V20" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
};
